const defaultLocale = {
  technicalData: 'All technical Data',
  allTechnicalData: 'See all technical data',
  batteryCapacity: 'Battery Capacity',
  body: 'Body',
  body_doors: 'Number of Doors',
  body_seats: 'Number of Seats installed',
  cabinTypeLabel: 'Cabin Type',
  cabinType_double: 'Double',
  cabinType_single: 'Single',
  consumption_combined: 'Consumption (combined operation)',
  drivetrain_awd: 'All-Wheel',
  drivetrain_fwd: 'Front-Wheel',
  drivetrain_rwd: 'Rear-Wheel',
  disclaimer:
    'Please note that the technical data given is based on the standard equipment. Optional equipment and configurations may affect these data.',
  driveTrain_fwd: 'Front-Wheel',
  driveTrain_rwd: 'Rear-Wheel',
  drivetrainType: 'Drivetrain',
  emissionsConsumption: 'CO2 emission (combined operation)',
  emissionsConsumption_consumption: 'Consuption',
  emissionsConsumption_emissions: 'Emissions',
  emissionsConsumption_fuelType: 'FuelType',
  emissionsConsumption_gearboxName: 'Gearbox',
  emissionsConsumption_standard: 'Exhaust emission standard',
  emissions_co2_combined: 'CO2 emission (combined operation)',
  engine: 'Engine Type',
  engine_range: 'WLTP fuel range total (aligned)',
  engine_rangeCity: 'WLTP fuel range total inner city (aligned)',
  engineType_diesel: 'Diesel',
  engineType_electric: 'Electric',
  engineType_petrol: 'Petrol',
  engine_capacity: 'Capacity',
  engine_torque: 'Torque',
  engine_kwPower: 'Power in kw',
  engine_hpPower: 'Horsepowe',
  engine_topSpeed: 'Top Speed',
  exterior: 'Exterior Dimensions',
  exterior_height: 'Vehicle Height',
  exterior_length: 'Vehicle Length',
  exterior_width: 'Vehicle Width',
  exterior_widthWithoutMirrors: 'Width with mirrors folded',
  interior: 'Interior Dimensions',
  alt_image_side: 'wheelbase and length',
  alt_imgage_front: 'width and height',
  alt_image_rear: 'loading space height',
  alt_image_top: 'loading space width and length',
  'bodytype_panel-van': 'panel-van',
  bodytype_tourer: 'tourer',
  bodytype_mixto: 'mixto',
  bodytype_chassis: 'chassis',
  'bodytype_chassis-cc': 'chassis-cc',
  'bodytype_chassis-pritsche': 'chassis-pritsche',
  loadingSpaceDimensions: 'Loading Space Dimensions',
  loadingSpaceDimensions_bootCapacity: 'Loading Space Volume',
  loadingSpaceDimensions_bootCapacityClosed: 'Luggage Space Volume',
  loadingSpaceDimensions_closed: 'Luggage Space Volume',
  loadingSpaceDimensions_heightMax: 'Loading Space Height',
  loadingSpaceDimensions_lengthMax: 'Loading Space Length',
  loadingSpaceDimensions_width: 'Loading Space Width',
  loadingSpaceDimensions_widthMax: 'Loading Space Width Max',
  loadingSpaceDimensions_widthMin: 'Loading Space Width Min',
  performance: 'Performance',
  roofTypeLabel: 'Roof Height',
  roofType_high: 'High',
  roofType_normal: 'Normal',
  roofType_superHigh: 'Super High',
  sizeTypeLabel: 'Vehicle Length',
  sizeType_compact: 'Compact',
  sizeType_extra_long: 'Extra long',
  sizeType_long: 'Long',
  sizeType_standard: 'Standard',
  transmission: 'Transmission',
  manual: 'Manual',
  automatic: 'Automatic',
  vehicleDimensions: 'Vehicle Dimensions',
  vehicleDimensions_height: 'Vehicle Height',
  vehicleDimensions_length: 'Vehicle Length',
  vehicleDimensions_wheelBase: 'Wheelbase',
  vehicleDimensions_width: 'Vehicle Width',
  vehicleDimensions_widthWithRetractedMirrors:
    'Vehicle Width with Mirrors folded',
  weight: 'Maximum Weight in Kg',
  weights: 'Weights',
  weights_automatic: 'Automatic weight',
  weights_manual: 'Manual weight',
  weights_kerbWeight: 'Kerb weight',
  weights_label: 'Gross Train Weight',
  weights_payloadMax: 'Permissible payload',
  weights_permissibleWeightTotal: 'Gross Train Weight',
  weights_weightMax: 'Permissible Gross Vehicle Weight',
  weights_trailingLoadWithBrakesMax: 'Braked Towing Capacity',
  weights_trailingLoadWithoutBrakesMax: 'Unbraked Towing Capacity',
  error_title: 'Technical data temporarily unavailable',
  error_message:
    'We are currently unable to display the technical data and dimensions for this vehicle. You can still continue browsing this page and explore all other information as usual.',
};

export function getDefaultLocaleValue(key: string): string {
  return defaultLocale[key as keyof typeof defaultLocale];
}
